import { action, Action } from 'easy-peasy';
import { isNumber } from 'lodash';

export interface INavigationCollapseModel {
    destroy: Action<INavigationCollapseModel>;
    /** ai 生成单个画布 */
    isAiCreate: boolean;
    setIsAiCreate: Action<INavigationCollapseModel, boolean>;
    /** ai 重新生成单个画布 */
    isAiRegen: boolean;
    regenIndex: number;
    setAiRegen: Action<INavigationCollapseModel, { regenIndex?: number; isAiRegen: boolean }>;
    closeAiPPTPrompt: Action<INavigationCollapseModel>;
}

export const navigationCollapseModel: INavigationCollapseModel = {
    destroy: action((state) => {
        state.isAiCreate = false;
        state.isAiRegen = false;
    }),
    closeAiPPTPrompt: action((state) => {
        state.isAiCreate = false;
        state.isAiRegen = false;
    }),

    isAiCreate: false,
    setIsAiCreate: action((state, payload) => {
        state.isAiCreate = payload;
    }),

    regenIndex: 0,
    isAiRegen: false,
    setAiRegen: action((state, { isAiRegen, regenIndex }) => {
        state.isAiRegen = isAiRegen;
        if (isNumber(regenIndex)) {
            state.regenIndex = regenIndex;
        }
    }),
};
